import {Action, handleActions} from "redux-actions";
import {LeadState} from "./LeadState";
import {
	LEAD_AGENT_UPDATED,
	LEAD_CREATED,
	LEAD_EDITED,
	LEAD_EVENTS_FETCHED,
	LEAD_FETCHED,
	LEAD_STATUS_UPDATED,
	LEAD_WATCHERS_UPDATED,
} from "../../action/lead/actionType";
import {none, option} from "ts-option";
import {TAGS_FETCHED, TAGS_SET_TO_LEAD} from "../../action/tag/actionType";
import _ = require("underscore");

/**
 * Initial state for leads.
 */
const initState: LeadState = {
	leadsMap: {},
	events: none,
	tags: none
};

const reducer = handleActions({
	[LEAD_CREATED]: (state: LeadState, action: Action<any>): LeadState => { //TODO: There is a bug with typings here. It is present only if action contains payload
		return {
			...state,
			leadsMap: {
				...state.leadsMap,
				[action.payload.lead.referenceNumber]: action.payload.lead,
				[action.payload.lead.id]: action.payload.lead
			}
		};
	},
	[LEAD_FETCHED]: (state: LeadState, action: Action<LEAD_FETCHED>): LeadState => {
		return {
			...state,
			leadsMap: {
				...state.leadsMap,
				[action.payload.lead.referenceNumber]: action.payload.lead,
				[action.payload.lead.id]: action.payload.lead
			}
		}
	},
	[LEAD_EDITED]: (state: LeadState, action: Action<LEAD_EDITED>): LeadState => {
		return {
			...state,
			leadsMap: {
				...state.leadsMap,
				[action.payload.lead.referenceNumber]: action.payload.lead,
				[action.payload.lead.id]: action.payload.lead
			}
		};
	},
	[LEAD_STATUS_UPDATED]: (state: LeadState, action: Action<LEAD_STATUS_UPDATED>): LeadState => {
		const lead = state.leadsMap[action.payload.leadId];
		const leadsMap = {...state.leadsMap};
		if (lead) {
			const updatedLead = lead.copy({statusId: action.payload.statusId});
			leadsMap[updatedLead.referenceNumber] = updatedLead;
			leadsMap[updatedLead.id] = updatedLead;
		}
		return {...state, leadsMap};
	},
	[LEAD_EVENTS_FETCHED]: (state: LeadState, action: Action<LEAD_EVENTS_FETCHED>): LeadState => {
		const events = state.events.getOrElse([]).filter(event => event.leadId != action.payload.leadId);
		return {...state, events: option(events.concat(action.payload.events))};
	},
	[LEAD_WATCHERS_UPDATED]: (state: LeadState, action: Action<LEAD_WATCHERS_UPDATED>): LeadState => {
		let lead = state.leadsMap[action.payload.leadId];
		const leadsMap = {...state.leadsMap};
		if (lead) {
			const updatedLead = lead.copy({watchers: action.payload.watchers});
			leadsMap[updatedLead.referenceNumber] = updatedLead;
			leadsMap[updatedLead.id] = updatedLead;
		}
		return {...state, leadsMap};
	},
	[LEAD_AGENT_UPDATED]: (state: LeadState, action: Action<LEAD_AGENT_UPDATED>): LeadState => {
		let lead = state.leadsMap[action.payload.leadId];
		const leadsMap = {...state.leadsMap};
		if (lead) {
			const updatedLead = lead.copy({agentId: action.payload.agentId});
			leadsMap[updatedLead.referenceNumber] = updatedLead;
			leadsMap[updatedLead.id] = updatedLead;
		}
		return {...state, leadsMap};
	},
	[TAGS_FETCHED]: (state: LeadState, action: Action<TAGS_FETCHED>): LeadState => {
		return {...state, tags: option(action.payload.tags)}
	},
	[TAGS_SET_TO_LEAD]: (state: LeadState, action: Action<TAGS_SET_TO_LEAD>): LeadState => {
		let lead = state.leadsMap[action.payload.leadId];
		const leadsMap = {...state.leadsMap};
		if (lead) {
			const updatedLead = lead.copy({tags: action.payload.tags});
			leadsMap[updatedLead.referenceNumber] = updatedLead;
			leadsMap[updatedLead.id] = updatedLead;
		}
		const tags = _.unique(state.tags.getOrElse([]).concat(action.payload.tags), (item) => item.name);
		return {...state, tags: option(tags), leadsMap}
	},
}, initState);

export default reducer;